import React from "react";
import Chart from "react-apexcharts";
import { ApexOptions } from "apexcharts";
import { Spin } from "antd";
import { MAP_SYMBOL_TO_DONUT_CHARTS, SymbolKeys } from "src/entity/main-report/main-report.entity";
import { formatNumber } from "src/utils/process-number";

interface PieDonutChartProps {
  loading: boolean;
  data: number[];
}

const PieDonutChart: React.FC<PieDonutChartProps> = ({ loading, data }) => {
  // Chart options
  const chartOptions: ApexOptions = {
    chart: {
      type: "donut", // Donut chart type
    },
    colors: ["#e1966a", "#f8e384", "#B5E2FA", "#48D1B8", "#FFE9BE", "#FA898B", "#D4A5F9"],
    labels: [
      MAP_SYMBOL_TO_DONUT_CHARTS[SymbolKeys.FUGITIVE],
      MAP_SYMBOL_TO_DONUT_CHARTS[SymbolKeys.COMBUSTION],
      MAP_SYMBOL_TO_DONUT_CHARTS[SymbolKeys.FLARE],
      MAP_SYMBOL_TO_DONUT_CHARTS[SymbolKeys.TERMINAL_MARKETING],
      MAP_SYMBOL_TO_DONUT_CHARTS[SymbolKeys.TANK],
      MAP_SYMBOL_TO_DONUT_CHARTS[SymbolKeys.WASTE_WATER],
      MAP_SYMBOL_TO_DONUT_CHARTS[SymbolKeys.OTHERS],
    ], // Categories
    legend: {
      position: "right", // Legend at the bottom
      markers: {
        shape: "square", // Change legend marker shape to square
      },
    },
    dataLabels: {
      enabled: false, // Disable labels on the chart stacks
    },
    plotOptions: {
      pie: {
        donut: {
          size: "55%", // Adjust the size of the donut hole
          labels: {
            show: false,
            total: {
              show: false, // Show valu in center on circle !
              label: "Total", // Label inside the donut hole
              formatter: () => "120", // Custom total value
            },
          },
        },
      },
    },
    tooltip: {
      fillSeriesColor: false,
      y: {
        formatter: (val) => `${formatNumber(val, 2)}`,
      },
      x: {
        formatter: (val) => `${formatNumber(val, 2)}`,
      },
      marker: {
        show: false,
      },
    },
  };

  // Chart series data
  // const seriesData = [44, 55, 41, 17, 15]; // Values corresponding to labels

  // console.log("[PieChart] data :: ", data);

  return (
    <div>
      {loading ? (
        <Spin spinning />
      ) : (
        <Chart
          options={chartOptions}
          series={data}
          type="donut" // Chart type is donut
          height={350}
        />
      )}
    </div>
  );
};

export default PieDonutChart;
